import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PaginaInicial from './pages/PaginaInicial';
import FormularioEnquete from './components/FormularioEnquete';
import FormularioTelaBrasil from './components/FormularioTelaBrasil';
import LoginAdmin from './pages/admin/LoginAdmin';
import DashboardHome from './pages/admin/DashboardHome';
import GerenciarEnquetes from './pages/admin/GerenciarEnquetes';
import ResultadosEnquetes from './pages/admin/ResultadosEnquetes';
import EditorEnquete from './pages/admin/EditorEnquete';
import PreviewEnquete from './pages/admin/PreviewEnquete';
import IpsBloqueados from './pages/admin/IpsBloqueados';
import LogsAuditoria from './pages/admin/LogsAuditoria';
import GerenciarUsuarios from './pages/admin/GerenciarUsuarios';
import RequireAuth from './components/admin/RequireAuth';
import PublicRouteGuard from './components/common/PublicRouteGuard';
import FormularioDinamico from './components/dynamic/FormularioDinamico';
import './index.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <Routes>
          {/* Página inicial: lista dinâmica de enquetes públicas.
              Toda rota pública fica dentro de PublicRouteGuard — quem tem
              sessão de admin/gerenciador válida é redirecionado na hora pra
              /admin, nunca "fica" numa rota pública. */}
          <Route path="/" element={<PublicRouteGuard><PaginaInicial /></PublicRouteGuard>} />

          {/* Portal de Entrada — reativada; a acessibilidade real é
              controlada pelo admin via toggle em Gerenciar Enquetes >
              Enquetes Legadas (backend responde 404 se estiver desligada) */}
          <Route path="/portal" element={<PublicRouteGuard><FormularioEnquete /></PublicRouteGuard>} />

          <Route path="/telaobrasilcb" element={<PublicRouteGuard><FormularioTelaBrasil /></PublicRouteGuard>} />

          {/* Enquetes dinâmicas (criadas via painel administrativo) */}
          <Route path="/e/:slug" element={<PublicRouteGuard><FormularioDinamico /></PublicRouteGuard>} />

          {/* Painel administrativo */}
          <Route path="/admin/login" element={<LoginAdmin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <DashboardHome />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/gerenciar-enquetes"
            element={
              <RequireAuth>
                <GerenciarEnquetes />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/resultados"
            element={
              <RequireAuth>
                <ResultadosEnquetes />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/enquetes/:id"
            element={
              <RequireAuth>
                <EditorEnquete />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/enquetes/:id/preview"
            element={
              <RequireAuth>
                <PreviewEnquete />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/seguranca/ips"
            element={
              <RequireAuth somenteAdmin>
                <IpsBloqueados />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/seguranca/logs"
            element={
              <RequireAuth somenteAdmin>
                <LogsAuditoria />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <RequireAuth>
                <GerenciarUsuarios />
              </RequireAuth>
            }
          />

          {/* Redireciona qualquer outra rota para a página inicial */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
